import {SoopLayer, useDialogContext} from '@soop-ui/soop-ui';
import {useSurveyForm} from '@/hooks/help';
import styles from './SurveyLayer.module.scss';
import SurveyBody from './SurveyBody';

interface SurveyLayerProps {
  isMobile: boolean;
  inquiryId: string;
  onSuccess: () => void;
}

const SurveyLayer = ({isMobile, inquiryId, onSuccess}: SurveyLayerProps) => {
  const {close} = useDialogContext();
  const {evaluateInquiry, surveyForm, setSurveyForm, isSubmitActive} =
    useSurveyForm({
      inquiryId,
      onSuccess: () => {
        onSuccess();
        close(false);
      },
    });

  return (
    <>
      <SoopLayer size='lg' onClose={() => close(false)}>
        <SoopLayer.Header align='center'>만족도 평가</SoopLayer.Header>
        <SoopLayer.Content>
          <SurveyBody
            isMobile={isMobile}
            surveyForm={surveyForm}
            setSurveyForm={setSurveyForm}
          />
        </SoopLayer.Content>
        <SoopLayer.Footer
          className={styles.SurveyFooter}
          align='center'
          primaryLabel='평가하기'
          buttonVariant='defaultPrimary'
          disabled={!isSubmitActive}
          onPrimaryClick={evaluateInquiry}
        />
      </SoopLayer>
    </>
  );
};

export default SurveyLayer;
